import { $, baseURL, importer } from '../utils/Utils';

const gmap = (() => {
  const config = {
    triggers: [...$('.js-map')],
    zoom: {
      default: 15,
      min: 12,
      max: 18,
    },
    center: { // this defaults to ÖBO coordinates
      lat: 59.2759646,
      lng: 15.2174338,
    },
    iconCN: 'map__marker',
  };

  const handleDataFromDOM = (trigger) => {
    let data;
    // JSON can fail and break the script
    try {
      data = JSON.parse(trigger.dataset.location);
    } catch (err) {
      data = {
        name: 'ÖrebroBostäder',
        location: config.center,
        zoom: config.zoom.default,
      };
    }

    return data;
  };

  const addLocation = ({ map, data }) => {
    const MarkerWithLabel = require('markerwithlabel')(google.maps);
    // Note: styling of the marker is done through css with the classname map__marker
    // The following is the little arrow at the bottom of the marker
    const icon = {
      url: `${baseURL}/images/arrow-down.svg`,
      scaledSize: new google.maps.Size(15, 6),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(7.5, 6),
    };

    // init gmap marker
    const marker = new MarkerWithLabel({
      map,
      position: data.location,
      icon,
      labelContent: data.name,
      labelClass: config.iconCN,
      labelInBackground: false,
      labelAnchor: new google.maps.Point(0, 0),
    });
  };

  const handleMap = (trigger) => {
    // retrieve map information from DOM markup
    const data = handleDataFromDOM(trigger);
    // make sure all data are available
    // map zoop
    const zoom = data.zoom || config.zoom.default;
    // center of the map: can be the location spot or ÖBO HQ coordinates
    const center = data.location || config.center;

    // init map
    const map = new google.maps.Map(trigger, {
      zoom,
      center,
      scrollwheel: false,
      streetViewControl: true,
    });
    // add location on map
    addLocation({ map, data });
  };

  const build = () => {
    // import script async with es6 premise
    importer
      .url('https://maps.googleapis.com/maps/api/js?key=AIzaSyC-ZIjn4JTEIx0GYbvyzDnJxPfaX_3S5ZY')
      .then(() => {
        config.triggers.forEach(trigger => handleMap(trigger));
      });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default gmap.init();

